export const LOCAL_STORAGE_BASKET_KEY = 'basket'
export const LOCAL_STORAGE_RECENT_PRODUCTS_KEY = 'recent'
export const MAX_RECENT_PRODUCTS = 10
